import { Badge } from '@/components/ui/badge'
import { CheckCircle2, AlertTriangle } from 'lucide-react'
import type { StatusAssinatura } from '@/hooks/useAssinaturas'

interface AssinaturaStatusBadgeProps {
  status: StatusAssinatura
  dataAssinatura?: string | null
}

function formatarData(s: string | null | undefined): string {
  if (!s) return ''
  try {
    const d = new Date(s)
    return d.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
  } catch {
    return s
  }
}

export function AssinaturaStatusBadge({ status, dataAssinatura }: AssinaturaStatusBadgeProps) {
  if (status === 'ASSINADO') {
    return (
      <Badge variant="secondary" className="bg-success/10 text-success gap-1">
        <CheckCircle2 className="h-3 w-3" />
        Assinado em {dataAssinatura ? formatarData(dataAssinatura) : '—'}
      </Badge>
    )
  }
  if (status === 'INVALIDADO') {
    return (
      <Badge variant="secondary" className="bg-warning/10 text-warning gap-1">
        <AlertTriangle className="h-3 w-3" />
        Assinatura invalidada
      </Badge>
    )
  }
  return null
}
